import { WEBFLOW_SCRIPT_BASE_URL } from '../src/webflow-script-baseURL';

export const storeCheckoutUpsellMap = async (SKUs: string[]) => {
  const siteId = window.FLOWPHANTOM_SITE_ID;

  const upsellFetch = await fetch(
    `${WEBFLOW_SCRIPT_BASE_URL}/api/v1-get-checkout-upsells`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ siteId, SKUs }),
    }
  );

  const upsellData = (await upsellFetch.json()) as {
    cartSKU: string;
    cartProductId: string;
    upsellProductId: string;
    upsellSKUs: string[];
    shippable: boolean;
  }[];

  localStorage.setItem('fp-ups', JSON.stringify(upsellData));

  return { upsellData };
};
